const VIZ_DISPLAY_NAMES: Record<string, string> = {
  abs_torsion: 'Absolute Torsion',
  torsion: 'Torsion',
  curvature_gradient: 'Curvature Gradient',
  torsion_gradient: 'Torsion Gradient',
};

/**
 * Maps a visualization key to its display name.
 * Falls back to replacing underscores with spaces if no mapping exists.
 */
export function vizDisplayName(key: string): string {
  return VIZ_DISPLAY_NAMES[key] ?? key.replace(/_/g, ' ');
}
